import http from "./httpClient.js";

export async function submitSchoolWaitlist(data) {
    const response = await http.post(`/school-waitlist`, data);
    return response.data;
}
